export default "__VITE_ASSET__OuOL_NxE__"